import { mainStepsIds } from './constants'
import { star_icon, finish_icon } from '../../Shared/icons';

export let mainSteps = [
    {
        id: mainStepsIds.Start,
        title: 'Start',
        icon: star_icon,
    },
    {
        id: mainStepsIds.Membership,
        title: 'USBC Membership',
    },
    {
        id: mainStepsIds.Bowler,
        title: 'Bowler',
    },
    {
        id: mainStepsIds.Consent,
        title: 'Consent',
    },
    {
        id: mainStepsIds.ReviewAndPay,
        title: 'Review & Pay',
    },
    {
        id: mainStepsIds.Finished,
        title: 'Finished',
        icon: finish_icon,
        denyStepsClick: true
    }
];